export const adminConfig = {
    // Secret code to unlock the admin login page (sourced from env; do not commit secrets)
    unlockCode:
      process.env.REACT_APP_ADMIN_UNLOCK_CODE ||
      (process.env.NODE_ENV === 'production' ? '' : 'admin'),
};